import { render, staticRenderFns } from "./CallModalView.vue?vue&type=template&id=235ac532&scoped=true&"
import script from "./CallModalView.vue?vue&type=script&lang=ts&"
export * from "./CallModalView.vue?vue&type=script&lang=ts&"
import style0 from "./CallModalView.vue?vue&type=style&index=0&id=235ac532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ac532",
  null
  
)

export default component.exports